<template lang="pug">
masked-input(
  v-bind="extendAttrs"
  @input="(val) => $emit('input', val)"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(
      :name="name"
      v-bind="data"
    )
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
import MaskedInput from '@/components/user-redesign/inputs/MaskedInput.vue';

const MASK = '###-###-### ##';

export default {
  name: 'SnilsInput',
  components: {
    MaskedInput,
  },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    extendAttrs() {
      const { $attrs, value } = this;
      return {
        mask: MASK,
        normalize: this.normalize,
        ...$attrs,
        label: 'СНИЛС',
        value,
      };
    },
  },
  watch: {},
  methods: {
    normalize(value) {
      return value.replace(/\D/g, '');
    },
  },
};
</script>
